import { render, staticRenderFns } from "./r-currency-group-dialog.vue?vue&type=template&id=a2dff1f4"
import script from "./r-currency-group-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-group-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2dff1f4')) {
      api.createRecord('a2dff1f4', component.options)
    } else {
      api.reload('a2dff1f4', component.options)
    }
    module.hot.accept("./r-currency-group-dialog.vue?vue&type=template&id=a2dff1f4", function () {
      api.rerender('a2dff1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-group/r-currency-group-dialog.vue"
export default component.exports